export enum AriaSort {
  Ascending = 'ascending',
  Descending = 'descending',
  None = 'none'
}


export interface OrdemColunaTabela {
  coluna: string,
  ordem: AriaSort;
}